import { DocumentResource, Resource } from 'ngx-jsonapi';
import { Transaction } from '@app/transactions/transaction';
import { UserFiscalData } from '@app/core/resources/user-fiscal-data';

export class Invoice extends Resource {
    public type: string = 'invoices';
    public attributes: {
        amount: number;
        status: string;
        status_message: string;
        invoice_url: string;
    } = {
        amount: 0,
        status: '',
        status_message: '',
        invoice_url: ''
    };

    public relationships: {
        transaction: DocumentResource<Transaction>;
        user_fiscal_data: DocumentResource<UserFiscalData>;
    } = {
        transaction: new DocumentResource<Transaction>(),
        user_fiscal_data: new DocumentResource<UserFiscalData>()
    };
}
